<template>
    <div v-show="show" class="tagInput-container">
        <div class="tagInputContent">
            <div class="title">{{title}}</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div class="form">
                <ul>
                    <li>
                        <div class="t b">标签分类</div>
                        <div class="dt">
                            <p class="b">添加标签</p>
                            <p>
                                <img src="./assets/notice.png" alt="">
                                <span>多个标签以空格分隔</span>
                            </p>
                        </div>
                    </li>
                    <li v-for="(item,index) in list" :key="index">
                        <div class="t">{{item.title}}</div>
                        <div class="input">
                            <input v-model="item.value" :placeholder="'请输入'+item.title+'相关标签…'" type="text">
                        </div>
                    </li>
                    <!-- <li>
                        <div class="t">地点</div>
                        <div class="input">
                            <input v-model="addressInput" placeholder="请输入地点相关标签…" type="text">
                        </div>
                    </li>
                    <li>
                        <div class="t">身份职务</div>
                        <div class="input">
                            <input v-model="userInput" placeholder="请输入身份职务相关标签…" type="text">
                        </div>
                    </li>
                    <li>
                        <div class="t">组织结构(其他）</div>
                        <div class="input">
                            <input v-model="statusInput" placeholder="请输入组织结构相关标签…" type="text">
                        </div>
                    </li>
                    <li>
                        <div class="t">关键词(其他）</div>
                        <div class="input">
                            <input v-model="keywordInput" placeholder="请输入关键词相关标签…" type="text">
                        </div>
                    </li> -->
                </ul>
            </div>
            <div @click="confirm" class="btn">确定</div>
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
    watch: {

    },
    data() {
        return {
            list: [],
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '添加自定义标签',
            timeInput: '',
            addressInput: '',
            userInput: '',
            statusInput: '',
            keywordInput: '',
        }
    },
    methods: {
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            this.list = config;
            this.show = true;
        },
        confirm() {
            // let info = {
            //     timeInput: this.timeInput,
            //     addressInput: this.addressInput,
            //     userInput: this.userInput,
            //     statusInput: this.statusInput,
            //     keywordInput: this.keywordInput
            // }
            let info = []
            this.list.forEach(el => {
                info.push({
                    type: el.type,
                    tags: el.value
                })
            })
            
            this.show = false;
            this.callback(info)

            this.list.forEach(el => {
                el.value = ''
            })
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        async close() {
            this.cancel()
        }
    }
}
</script>

<style lang="less">
    .tagInput-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .tagInputContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 700px;
            // height: 439px;
            display: flex;
            flex-direction: column;
            // margin-left: -350px;
            // margin-top: -219px;
            transform: translate(-50%, -50%);
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 20px 0px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                color: #323B4B;
                margin-bottom: 16px;
                padding-left: 30px;
                box-sizing: border-box;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .form {
                padding-top: 19px;
                box-sizing: border-box;
                width: 100%;
                height: 300px;
                overflow-y: auto;
                padding: 0 30px;
                box-sizing: border-box;
                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: #ddd;
                    border-radius: 4px;
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        margin-bottom: 20px;

                        .t {
                            width: 110px;
                            font-size: 13px;
                            line-height: 18px;
                            color: #666666;

                            &.b {
                                font-size: 14px;
                                line-height: 20px;
                                font-weight: bold;
                                color: #829191;
                            }
                        }

                        .dt {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            flex: 1;

                            p {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                &.b {
                                    font-size: 14px;
                                    line-height: 20px;
                                    font-weight: bold;
                                    color: #829191;
                                }

                                img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 6px;
                                }

                                span {
                                    font-size: 14px;
                                    color: #B9C3C3;
                                }
                            }
                        }

                        .input {
                            flex: 1;

                            input {
                                width: 100%;
                                height: 30px;
                                font-size: 13px;
                                color: #323B4B;
                                background: #F3F5F6;
                                border-radius: 2px;
                                padding: 0 14px;
                                box-sizing: border-box;

                                &::placeholder {
                                    font-size: 12px;
                                    color: #C4CBD1;
                                }
                            }
                        }
                    }
                }
            }

            .btn {
                width: 120px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #41B48C;
                border-radius: 4px;
                margin: 0 auto;
                font-size: 14px;
                font-weight: bold;
                color: #FFF;
                user-select: none;
                cursor: pointer;
            }
        }
    }
</style>